module.exports = __webpack_public_path__ + "static/1-9bf77c54fc7a3bb0ee12ef4f58e0fe4f.jpg";